import { Box } from "@mui/material";
import Footer from ".";

/**
 * v1 pages that keep their v1 content but pick up the v2 nav (config.v2.nav)
 * still need the v1 Footer - MainContainer and PublicRoute's useV2Nav branch
 * renders this instead of raw children, since without it those pages lost
 * the footer entirely (v2-native pages supply their own via
 * SidebarLegalFooter instead, via useV2Layout, which bypasses both).
 * flexGrow on the children wrapper pushes the footer to the bottom of the
 * scrollable viewport when the page content is shorter than the screen,
 * instead of leaving it floating above a gap of empty space.
 */
export function StickyFooterShell({
  children,
}: {
  children: React.ReactNode;
}) {
  return (
    <Box sx={{ display: "flex", flexDirection: "column", minHeight: "100%" }}>
      <Box sx={{ flexGrow: 1 }}>{children}</Box>
      <Footer />
    </Box>
  );
}
